import type { ExploreWorkspaceSeed } from '../workspaceSeeds'

export const SCHOOL_DEMO_SEED: ExploreWorkspaceSeed = {
  id: 'school-demo',
  name: 'Oakridge International School',
  slug: 'school-demo',
  summary: 'A full K-12 teaching workspace with class trees, timetable, attendance, grading, report cards, fees, and admissions.',
  tags: ['education', 'teaching', 'school', 'cbse'],
  metrics: [
    { label: 'Learners', value: '30 enrolled' },
    { label: 'Classes', value: 'Grade 6 & 7' },
  ],
  currency: 'INR',
  budgetLabel: '₹15,000 / term',
  quotaLabel: '30 / 30 seats',
  sensitiveDemo: {
    label: 'Fake school demo data',
    items: [
      'teacher-sunita-rao@example.test',
      'All student data is synthetic (@example.test)',
    ],
  },
  members: [
    { name: 'Dr. Sunita Rao', email: 'sunita.rao@example.test', role: 'ADMIN' },
    { name: 'Rajesh Sharma', email: 'rajesh.sharma@example.test', role: 'EDITOR' },
    { name: 'Ananya Sen', email: 'ananya.sen@example.test', role: 'EDITOR' },
    { name: 'Vikram Patel', email: 'vikram.patel@example.test', role: 'EDITOR' },
    { name: 'Priya Nair', email: 'priya.nair@example.test', role: 'EDITOR' },
  ],
  elements: [],
  checklistItems: [],
  featured: true,
  heroGradient: 'AURORA',
}
